import * as Yup from 'yup';
import { passwordPolicySchema } from '@/utils/passwordSchema';

export const CreatePasswordSchema = Yup.object().shape({
  password: passwordPolicySchema,
  confirmPassword: Yup.string()
    .trim()
    .required('Confirmar a Senha é obrigatório')
    .oneOf([Yup.ref('password'), null], 'As Senhas devem corresponder'),
});
